import { configureStore } from '@reduxjs/toolkit';
import projectsReducer from './reducers/ProjectsSlice';
import drawerReducer from './reducers/DrawerSlice'

export default configureStore({
    reducer: {
        projects: projectsReducer,
        drawer: drawerReducer,
    }
})